/* eslint-disable */
import React from'react';

var ErrorTestPage=function ErrorTestPage(){return(
React.createElement("div",{className:"error-test-page"},thisFunctionDoesNotExist()));};


export default ErrorTestPage;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9wYWdlcy9FcnJvclRlc3RQYWdlL0Vycm9yVGVzdFBhZ2UuanN4Il0sIm5hbWVzIjpbIlJlYWN0IiwiRXJyb3JUZXN0UGFnZSIsInRoaXNGdW5jdGlvbkRvZXNOb3RFeGlzdCJdLCJtYXBwaW5ncyI6IkFBQUE7QUFDQSxNQUFPQSxNQUFQLEtBQWtCLE9BQWxCOztBQUVBLEdBQU1DLGVBQWdCLFFBQWhCQSxjQUFnQjtBQUNwQiwyQkFBSyxVQUFVLGlCQUFmLEVBQWtDQywwQkFBbEMsQ0FEb0IsR0FBdEI7OztBQUlBLGNBQWVELGNBQWYiLCJmaWxlIjoiRXJyb3JUZXN0UGFnZS5qc3giLCJzb3VyY2VSb290IjoiL2FwcCIsInNvdXJjZXNDb250ZW50IjpbIi8qIGVzbGludC1kaXNhYmxlICovXG5pbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuXG5jb25zdCBFcnJvclRlc3RQYWdlID0gKCkgPT4gKFxuICA8ZGl2IGNsYXNzTmFtZT1cImVycm9yLXRlc3QtcGFnZVwiPnt0aGlzRnVuY3Rpb25Eb2VzTm90RXhpc3QoKX08L2Rpdj5cbik7XG5cbmV4cG9ydCBkZWZhdWx0IEVycm9yVGVzdFBhZ2U7XG4iXX0=


//////////////////
// WEBPACK FOOTER
// ./src/pages/ErrorTestPage/ErrorTestPage.jsx
// module id = 2028
// module chunks = 0